import React from 'react';
import Button from '../Button';
import { UNLogoIcon, WFPIcon } from '../../assets/svg';
import './styles.scss';

interface IHeader {
  activeLang?: string;
  languages?: string[];
  logo?: JSX.Element | null;
  panelIcon?: JSX.Element | null;
  name?: JSX.Element;
  serviceName?: string;
  username: string;
  logout: () => void;
  onLangChange?: (value: string) => void;
  onLogoClick?: () => void;
}

const Header: React.FC<IHeader> = ({
  activeLang,
  languages,
  logo,
  panelIcon,
  name,
  serviceName = 'facility',
  username = '',
  logout,
  onLangChange,
  onLogoClick,
}) => {
  const getDefaultName = () => (
    <div className="hbh-service-name">
      <h1 className="hbh-service-title">{serviceName}</h1>
      <h3>Digital Office</h3>
    </div>
  );

  const getLanguages = () => (
    <div className="hbh-language-switcher">
      {languages?.map((lang) => (
        <Button
          className={lang === activeLang ? 'active' : undefined}
          key={lang}
          text={lang}
          variant="link"
          onClick={() => onLangChange?.(lang)}
        />
      ))}
    </div>
  );

  const Logo = () => {
    if (logo === null) {
      return null;
    }

    return logo ?? <UNLogoIcon width='50' height='42' />;
  };


  return (
    <header className='hbh-header'>
      <div className='hbh-logo' onClick={() => onLogoClick?.()}>
        <Logo/>
        {name ? name : getDefaultName()}
      </div>

      <div className="hbh-header-panel">
        {panelIcon ? panelIcon : <WFPIcon width='50' height='42'/>}
        <div className="hbh-status-bar">
          {languages ? getLanguages() : null}

          <div className="hbh-status-container">
            <span>
              Hello <b>{username}</b>,
            </span>
            <Button className="hbh-btn-logout" text="Logout" variant="link" onClick={logout} />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
